import configBackground from '../wob-background-menu'
import * as configOutline from '../wob-outline-menu'
import WidgetConfigMenu from '../widget-config-menu'

var TextWidgetConfig = WidgetConfigMenu.extend({
	typeSpecificTargets: function (hasTemplate) {
		return [
			configBackground(this.model.properties),
			configOutline.width(this.canvas),
			configOutline.color(this, this.model)
		]
	}
})

export default TextWidgetConfig

TextWidgetConfig.__filename__ = 'dashboards/widgets/text/text-widget-config.js'
